import React from "react";
import TimeSlotGrid from "../TimeSlotGrid";
import {
  TimeSlot,
  BookingLanguage,
  BookingStep,
  FastBookingSlots,
} from "@/types/booking";
import { useClinics } from "@/hooks/useClinics";
import type { SlotSelectionUpdateOptions } from "@/hooks/booking/useTimeSlots";

interface TimeSlotSelectorProps {
  currentDate: Date;
  bookingType: "request";
  setBookingType: (type: "request") => void;
  onTimeSelect: (times: string[], options?: SlotSelectionUpdateOptions) => void;
  language: BookingLanguage;
  selectedTimeSlots: TimeSlot[];
  onDeleteTimeSlot: (slot: TimeSlot) => void;
  setCurrentStep: (step: BookingStep) => void;
  selectedClinic: string;
  onBack?: () => void;
  hideTitle?: boolean;
  preference?: "first" | "second";
  isEditing?: boolean;
  showSlotIndicators?: boolean;
  useExternalSlotsOnly?: boolean;
}

const TimeSlotSelector = ({
  currentDate,
  bookingType,
  setBookingType,
  onTimeSelect,
  language,
  selectedTimeSlots,
  onDeleteTimeSlot,
  setCurrentStep,
  selectedClinic,
  onBack,
  hideTitle = false,
  preference,
  isEditing = false,
  showSlotIndicators = false,
  useExternalSlotsOnly = false,
}: TimeSlotSelectorProps) => {
  console.log("TimeSlotSelector - Selected clinic:", selectedClinic);

  const { data: clinics } = useClinics();
  const currentClinic = clinics?.find((c) => c.id === selectedClinic);
  const fastBookingSlots = currentClinic?.fast_booking_slots as
    | FastBookingSlots
    | undefined;

  return (
    <TimeSlotGrid
      date={currentDate}
      onTimeSelect={onTimeSelect}
      bookingType={bookingType}
      setBookingType={setBookingType}
      language={language}
      selectedTimeSlots={selectedTimeSlots}
      onDeleteTimeSlot={onDeleteTimeSlot}
      setCurrentStep={setCurrentStep}
      selectedClinic={selectedClinic}
      onBack={onBack}
      hideTitle={hideTitle}
      preference={preference}
      allowSelectionOverride={isEditing}
      showSlotIndicators={showSlotIndicators}
      useExternalSlotsOnly={useExternalSlotsOnly}
    />
  );
};

export default TimeSlotSelector;
